export const AddressColumns = [
    "s_no",
    "destination",
    "delivery_address",
    "buyer_address",
    "buyer_code",
    "delivery_code",
    "revised_delivery_address"

  
]